import { trendArticles } from "@/mocks/siteData";
import SectionHeader from "./SectionHeader";

export default function TrendSection() {
  return (
    <section id="trend" className="relative scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="热点盘点"
          title="本周大瓜 · 趋势深读"
          desc="不只看热闹，更帮你读懂热闹背后的逻辑。每周从现象级话题出发，整理出有信息量与参考价值的专题内容。"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {trendArticles.map((a) => (
            <article
              key={a.rank}
              className="group rounded-2xl overflow-hidden border border-background-200 bg-background-100 flex flex-col transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden">
                <img
                  src={a.image}
                  alt={`${a.title}专题配图`}
                  title={`${a.title}专题`}
                  className="w-full h-52 md:h-56 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 flex items-center gap-1 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-bold">
                  <i className="ri-number-1 text-sm w-4 h-4 flex items-center justify-center"></i>
                  第 {a.rank} 期盘点
                </span>
                <span className="absolute right-4 bottom-3 px-2 py-0.5 rounded bg-accent-500 text-primary-950 text-[11px] font-semibold">
                  {a.tag}
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading font-bold text-lg text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors cursor-pointer">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{a.summary}</p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm w-4 h-4 flex items-center justify-center"></i>
                    {a.reads} 阅读
                  </span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary-600 cursor-pointer">
                    展开阅读 <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}